import { create, clickable, collection, isPresent, text, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/versions'),
  create: clickable('[data-test-add-version]'),
  canCreate: isPresent('[data-test-add-version]'),
  versions: collection('[data-test-versions] tbody tr', {
    name: text('td:eq(0)'),
    visit: clickable('td:eq(0) a'),
    status: text('td:eq(1)'),
    created: text('td:eq(2)'),
    providers: collection('td:eq(4) .hds-badge')
  })
});